import { render, staticRenderFns } from "./scientific-analysis-summary-detail.vue?vue&type=template&id=4b1373f1&"
import script from "./scientific-analysis-summary-detail.ts?vue&type=script&lang=ts&"
export * from "./scientific-analysis-summary-detail.ts?vue&type=script&lang=ts&"
import style0 from "./scientific-analysis-summary-detail.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports